<template>
  <div v-click-outside="onClickOutside">
    <slot
      name="trigger"
      :show="scopedSlots.show"
      :hide="scopedSlots.hide"
      :toggle="scopedSlots.toggle"
      :is-showing="scopedSlots.isShowing"
    ></slot>

    <aside
      class="tooltip-content-wrapper"
      :class="{ 'not-active': !isShowing }"
    >
      <transition name="fade">
        <slot
          v-if="isShowing"
          :show="scopedSlots.show"
          :hide="scopedSlots.hide"
          :toggle="scopedSlots.toggle"
          :is-showing="scopedSlots.isShowing"
        />
      </transition>
    </aside>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import EventBus from "../../helpers/eventBus";

export default {
  props: {
    enableClickOutside: {
      type: Boolean,
      required: false,
      default: () => true,
    },
    clickOutsideWithout: {
      type: String,
      default: "",
    },
    namespace: {
      type: String,
      default: "",
    },
    tooltipId: {
      type: String,
      default: "",
    },
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      isShowing: false,
      isLockingUpdate: false,
    };
  },
  mounted() {
    this.popupItem = this.$el;

    this.hideTooltip = () => {
      this.isShowing = false;
    };

    this.hideOthers = (e) => {
      if (this.namespace && e.namespace === this.namespace) {
        if (this.tooltipId && e.tooltipId !== this.tooltipId) {
          this.isShowing = false;
        }
      }
    };

    EventBus.$on("tooltip:hide", this.hideTooltip);
    EventBus.$on("tooltip:hide-others", this.hideOthers);
  },
  beforeDestroy() {
    EventBus.$off("tooltip:hide", this.hideTooltip);
    EventBus.$off("tooltip:hide-others", this.hideOthers);
  },
  computed: {
    scopedSlots() {
      return {
        show: this.show.bind(this),
        hide: this.hide.bind(this),
        toggle: this.toggle.bind(this),
        isShowing: this.isShowing,
      };
    },
  },
  methods: {
    show() {
      this.isLockingUpdate = true;
      this.isShowing = true;
      setTimeout(() => {
        this.isLockingUpdate = false;
      }, 100);
    },
    hide() {
      if (!this.isLockingUpdate) {
        this.isShowing = false;
      }
    },
    toggle() {
      this.isShowing = !this.isShowing;
    },
    onClickOutside(e) {
      if (!this.enableClickOutside) return;

      if (this.clickOutsideWithout) {
        if ($(e.target).parents(this.clickOutsideWithout).length === 0) {
          this.hide();
        }
      } else {
        this.hide();
      }
    },
  },
  watch: {
    isShowing(value) {
      if (value) {
        this.$emit("show");

        if (this.namespace && this.tooltipId) {
          EventBus.$emit("tooltip:hide-others", {
            namespace: this.namespace,
            tooltipId: this.tooltipId,
          });
        }
      } else {
        this.$emit("hide");
      }
    },
  },
};
</script>
